module.exports = __webpack_public_path__ + "static/media/img_15.9404cf78.png";